import { ReportTemplateIdEnum } from "@ryde/shared";

export const ANALYTIC_REPORT_LABEL_KEYS: Record<string, string> = {
  [ReportTemplateIdEnum.RIDE_ANALYTICS_REPORT]:
    "dashboard.dynamic.analytic.rides",
  [ReportTemplateIdEnum.SUPPLIER_RIDE_ANALYTICS_REPORT]:
    "dashboard.dynamic.analytic.ridesSupplier",
  BOOKINGS_ANALYTICS_REPORT: "dashboard.dynamic.analytic.bookings",
  FEEDBACKS_ANALYTICS_REPORT: "dashboard.dynamic.analytic.feedbacks",
};
